import { z } from 'zod';
import { makeRequiredIPAddressSchema } from '../general/required-ip-address.ts';
import { mapStringToDNSHostOrOriginal } from './helpers/dns.ts';

export const lighthouseDNSOnHostSchema = z
  .string()
  .transform(mapStringToDNSHostOrOriginal)
  .pipe(makeRequiredIPAddressSchema());
export const lighthouseDNSOffHostSchema = z.string();
